import { ArrowBack } from "@material-ui/icons";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import "./StoryHeader.scss";

type Props = {
    id: string;
    title: string;
    writterName: string;
    reviewed: boolean;
    openfeed: () => void;
};

const StoryHeader: React.FC<Props & RouteComponentProps> = (props) => (
    <div className="header__nav story-header">
        <div className="header__left">
            <ArrowBack onClick={() => props.history.goBack()} />
            <div>
                <div className="story__title">{props.title}</div>
                <div className="story__writter">{props.writterName}</div>
            </div>
        </div>
        <div className="header__right">
            <button
                className="white__btn"
                style={{ width: "250px" }}
                onClick={props.openfeed}
            >
                {props.reviewed ? "View" : "Give"} feedback on this story
            </button>
        </div>
    </div>
);

export default withRouter(StoryHeader);
